import React, { useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { normalizeImageUrl } from '../utils/imageUtils';
import { useData } from '../context/DataContext';

const ServicesPage = () => {
    const { slug } = useParams();
    const location = useLocation();
    const { serviceGroups: groups, loading } = useData();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    // Lọc nhóm nếu có slug (khi vào qua /dich-vu-nhom/:slug)
    const displayedGroups = slug 
        ? groups.filter(g => g.slug === slug) 
        : groups;

    if (loading) {
        return (
            <div className="container py-24 flex flex-col items-center">
                <div className="w-16 h-16 border-4 border-slate-100 border-t-red-600 rounded-full animate-spin mb-4"></div>
                <p className="text-slate-500 font-medium animate-pulse">Đang tải danh sách dịch vụ...</p>
            </div>
        );
    }

    return (
        <main className="product-category" style={{ backgroundColor: '#f4f7f6', paddingBottom: 60 }}>
            {/* ════ MINIMAL BREADCRUMBS ════ */}
            <div className="py-4 mt-[50px]">
                <div className="container px-4">
                    <nav className="flex items-center gap-2 text-xs md:text-sm uppercase tracking-wider">
                        <Link to="/" className="hover:text-red-600 transition-colors no-underline text-slate-500">Trang chủ</Link>
                        <span className="opacity-30">/</span>
                        <span className="text-slate-900 font-bold">Dịch vụ</span>
                    </nav>
                </div>
            </div>

            <div className="container">
                <h1 className="text-center" style={{ margin: '0 0 50px 0', fontSize: '32px', fontWeight: 'bold', textTransform: 'uppercase', color: '#333' }}>
                    <span>{slug && displayedGroups.length > 0 ? displayedGroups[0].name : 'Dịch vụ của chúng tôi'}</span>
                    <div style={{ width: '60px', height: '3px', backgroundColor: '#ff0000', margin: '15px auto 0' }}></div>
                </h1>

                {displayedGroups.map(group => {
                    const groupId = group._id || group.id;
                    const groupItems = group.items || [];
                    
                    return (
                        <section key={groupId} className="mb-5" style={{ background: '#fff', borderRadius: '12px', padding: '40px 30px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                            <div className="d-flex flex-column align-items-center mb-5 text-center">
                                {/* Ảnh mặt đại diện của Service Group */}
                                {group.imageUrl && (
                                    <Link to={`/dich-vu-nhom/${group.slug}`}>
                                        <img 
                                            src={normalizeImageUrl(group.imageUrl)} 
                                            alt={group.name} 
                                            style={{ 
                                                width: '120px', 
                                                height: '120px', 
                                                objectFit: 'cover', 
                                                borderRadius: '50%', 
                                                marginBottom: '15px', 
                                                border: '3px solid #ff0000', 
                                                padding: '3px',
                                                boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                                            }} 
                                        />
                                    </Link>
                                )}
                                <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#ff0000', textTransform: 'uppercase', margin: 0 }}>
                                    <Link to={`/dich-vu-nhom/${group.slug}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                                        {group.name}
                                    </Link>
                                </h2>
                                {group.description && (
                                    <p style={{ color: '#666', marginTop: '10px', maxWidth: '750px', lineHeight: '1.6' }}>
                                        {group.description}
                                    </p>
                                )}
                            </div>

                            <div className="row justify-content-center">
                                {groupItems.length > 0 ? groupItems.map((item, idx) => (
                                    <div key={idx} className="col-lg-3 col-md-6 mb-4">
                                        <div style={{
                                            backgroundColor: '#f9f9f9',
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                            height: '100%',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            border: '1px solid #eee'
                                        }} className="service-card-item">
                                            <Link to={`/dich-vu/${item.slug}`} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                                <div style={{ position: 'relative', height: '180px', overflow: 'hidden' }}>
                                                    <img
                                                        src={normalizeImageUrl(item.imageUrl || '/assets/images/service-default.jpg')}
                                                        alt={item.title}
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s' }}
                                                        className="service-img"
                                                    />
                                                </div>
                                                <div style={{ padding: '20px', textAlign: 'center', flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                                    <h4 style={{
                                                        fontSize: '16px',
                                                        fontWeight: '700',
                                                        lineHeight: '1.4',
                                                        margin: 0,
                                                        color: '#333'
                                                    }}>
                                                        {item.title}
                                                    </h4>
                                                    {item.price > 0 && (
                                                        <div style={{ marginTop: '10px', color: '#ff0000', fontWeight: 'bold' }}>
                                                            Từ {item.price.toLocaleString('vi-VN')} đ
                                                        </div>
                                                    )}
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )) : (
                                    <div className="col-12 text-center text-muted" style={{ fontStyle: 'italic' }}>
                                        Chưa có dịch vụ nào trong nhóm này.
                                    </div>
                                )}
                            </div>
                        </section>
                    );
                })}

                {displayedGroups.length === 0 && !loading && (
                    <div className="text-center py-5" style={{ background: '#fff', borderRadius: '12px' }}>
                        <p style={{ fontSize: '16px', color: '#666' }}>Không tìm thấy nhóm dịch vụ nào.</p>
                        <Link to="/dich-vu" className="btn btn-primary mt-3" style={{ background: '#ff0000', border: 'none', padding: '10px 30px', fontWeight: 'bold', borderRadius: '30px' }}>
                            Xem tất cả dịch vụ
                        </Link>
                    </div>
                )}
            </div>

            <style>{`
                .service-card-item:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 25px rgba(0,0,0,0.12) !important;
                    border-color: #ff0000 !important;
                }
                .service-card-item:hover .service-img {
                    transform: scale(1.08);
                }
                .service-card-item .service-img {
                    transition: transform 0.4s ease;
                }
            `}</style>
        </main>
    );
};

export default ServicesPage;



